const S = {
  cyan:{ bg:"#E0F7FA", border:"#1CBCD3" }, gold:{ bg:"#FBF4E8", border:"#C9922A" },
  royal:{ bg:"#E3F2FD", border:"#1263B0" }, red:{ bg:"#FEF2F2", border:"#EF4444" },
};
export default function Callout({ children, variant="cyan", icon }) {
  const s = S[variant]||S.cyan;
  return (
    <div style={{ display:"flex", gap:"10px", alignItems:"flex-start",
      padding:"12px 16px", borderRadius:"0 12px 12px 0",
      borderLeft:"4px solid " + s.border, background:s.bg,
      marginBottom:"16px", fontSize:"13px", lineHeight:"1.6", color:"#1E293B" }}>
      {icon&&<span style={{flexShrink:0}}>{icon}</span>}
      <span>{children}</span>
    </div>
  );
}
